import React from 'react';
import { motion } from "motion/react";
import { ImagePlaceholder } from '@/features/home/utils';

const CTASection: React.FC = () => {
    const containerVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.8,
                staggerChildren: 0.1,
                delayChildren: 0.2,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
            },
        },
    };

    const buttonVariants = {
        hover: {
            scale: 1.02,
            transition: {
                duration: 0.2,
            },
        },
        tap: {
            scale: 0.98,
        },
    };

    return (
        <section className="max-w-8xl mx-auto px-8 py-24">
            <motion.div 
                className="relative overflow-hidden text-white rounded-3xl bg-gray-900 border border-gray-800"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                 <div className="absolute inset-0 opacity-20">
                    <ImagePlaceholder label="Abstract club lights" className="rounded-none"/>
                 </div>
                <div className="relative text-center p-12 sm:p-20">
                    <motion.h2 
                        className="text-5xl font-serif font-medium mb-6"
                        variants={itemVariants}
                    >
                        Join The Guest List
                    </motion.h2>
                    <motion.p 
                        className="text-xl opacity-90 mb-8 max-w-2xl mx-auto"
                        variants={itemVariants}
                    >
                        Be the first to know about new events, exclusive access, and member-only drops.
                    </motion.p>
                    <motion.div 
                        className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8"
                        variants={itemVariants}
                    >
                        <input 
                            type="email" 
                            placeholder="Enter your email" 
                            className="px-6 py-4 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/30 w-full sm:w-80" 
                        />
                        <motion.button 
                            className="px-8 py-4 bg-white text-black rounded-full font-medium hover:bg-gray-200 transition-colors w-full sm:w-auto"
                            variants={buttonVariants}
                            whileHover="hover"
                            whileTap="tap"
                        >
                            Subscribe
                        </motion.button>
                    </motion.div>
                    <motion.p 
                        className="text-sm opacity-70"
                        variants={itemVariants}
                    >
                        No spam, just exclusive access.
                    </motion.p>
                </div>
            </motion.div>
        </section>
    );
};

export default CTASection;
